<template>
  <div v-if="loaded" class="container__ask_code">
    <section class="to-block">
      <div
        class="container"
        style="
          height: calc(100vh);
          z-index: 100000;
          position: absolute;
          max-width: 100%;
          background: #000;
          padding: 0px;
        "
      >
        <div
          class="row justify-content-center"
          style="margin: 0px; background: #000"
        >
          <div class="col-12 col-md-12 col-lg-12 text-center">
            <div class="container-prime to-box to-touch pt-4">
              <form v-on:submit.prevent="login" class="form-signin">
                <div v-if="showwatch == 'login'">
                  <div class="row mb-4">
                    <div class="col">
                      <div>
                        <img
                          class="logo-corporativo-ask-code"
                          src="/assets/images/logocorporativobilheteria.png"
                        />
                      </div>
                      <!-- <h2 class="txts-askcode-bilheteria">
                        BILHETERIA.COM PORTAL CORPORATIVO
                      </h2> -->
                      <h2
                        class="txts-login-bilheteria"
                        style="
                          font-size: 19px;
                          max-width: 40%;
                          margin: 14px auto;
                          color: #fff !important;
                          text-transform: uppercase;
                        "
                      >
                        Bem-vindo ao programa corporativo de entretenimentos
                        exclusivo para funcionários e colaboradores de empresas
                        conveniadas.
                      </h2>
                    </div>
                  </div>
                  <!-- <hr data-content class="divider" /> -->
                  <h2
                    class="txts-login-bilheteria"
                    style="font-size: 15px; color: #fff !important"
                  >
                    ENTRE COM O CÓDIGO DE ACESSO DA SUA EMPRESA
                  </h2>
                  <div class="row wrapper_login">
                    <div
                      class="col mt-2"
                      style="display: flex; justify-content: center"
                    >
                      <input
                        style="max-width: 250px; text-align: center"
                        type="text"
                        id="inputPassword"
                        v-model="form.pass"
                        placeholder="Código da Empresa"
                        required
                        v-bind:class="{
                          errorinputuser: !validateinfo.pass,
                          'form-control': true,
                        }"
                      />
                      <span
                        class=""
                        style="
                          text-align: center;
                          padding: 10px;
                          margin-left: -33px;
                        "
                        title="CEP"
                      >
                        <i class="fas fa-key"></i>
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col mt-4">
                      <button
                        style="
                          min-width: 315px;
                          border: none;
                          background: #fdc80a !important;
                          color: #000 !important;
                        "
                        class="btn mb-2 btn-success"
                        type="button"
                        @click="login"
                      >
                        <i class></i>
                        <v-wait for="inprocess">
                          <template slot="waiting">Aguarde...</template>
                        </v-wait>
                        <!-- <span v-if="processing">Aguarde...</span> -->
                        <span class="txt-btn-entrar" v-if="!processing"
                          >Entrar</span
                        >
                      </button>
                      <p class="mt-3" style="color: #fff; font-size: 14px">
                        Esqueceu ou não tem o código de acesso de sua empresa?
                        <a
                          href="#"
                          id="forgot_pswd"
                          @click="$router.push('requestCode')"
                          >CLIQUE AQUI!</a
                        >
                      </p>
                      <p class="mt-3" style="color: #fff; font-size: 14px">
                        Para saber mais sobre esse portal.
                        <a href="#" id="" onclick="window.location='https://bws.bilheteria.com/'"
                          >CLIQUE AQUI!</a
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="container-social">
              <div class="social-media">
                <h3 style="text-align: center; color: #fff; font-size: 15px">
                  Siga-nos
                </h3>
                <a
                  href="https://www.facebook.com/bilheteriacom/"
                  target="blank"
                >
                  <img
                    class="social-media-img"
                    src="/assets/images/logo-facebook.png"
                    alt
                  />
                </a>
                <a
                  href="https://www.instagram.com/bilheteriacom/"
                  target="blank"
                >
                  <img
                    class="social-media-img"
                    src="/assets/images/logo-instagram.png"
                    alt
                  />
                </a>
                <a href="https://twitter.com/bilheteriacom" target="blank">
                  <img
                    class="social-media-img"
                    src="/assets/images/logo-twitter.png"
                    alt
                  />
                </a>
                <a
                  href="https://www.youtube.com/channel/UC1_gz9OCwU49rIzLZB0QlWg"
                  target="blank"
                >
                  <img
                    class="social-media-img"
                    src="/assets/images/logo-youtube.png"
                    alt
                  />
                </a>
              </div>
            </div>
              <div class="container-social" style="margin-top: 50px;display: block;">
                <div>
                  <h2 class="txts-login-bilheteria" style="font-size: 19px; margin: 14px auto; color: #fff !important;">
                    BAIXE AGORA O NOSSO APP
                  </h2>
          </div>
              <div style="margin-bottom: 10px;">
                <a href="#" id="" onclick="window.location='https://play.google.com/store/apps/details?id=com.bilheteria.entretenimentos'">
                <img width="200px" src="/assets/images/logo-app-google.png"/>
                </a>
                <a href="#" id="" onclick="window.location='https://apps.apple.com/us/app/bilheteria-entretenimentos/id1636326264'">
                <img width="203px" src="/assets/images/logo-app-apple.png"/>
                </a>
        </div>
      </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from "vue";
import VModal from "vue-js-modal";
import config from "@/config";
import { func } from "@/functions";
import { authService } from "@/components/common/services/auth";
import { corporateService } from "@/components/common/services/corporate";
import { partnerService } from "@/components/common/services/partner";

Vue.use(VModal, {
  dynamic: true,
  injectModalsContainer: true,
});

export default {
  mixins: [func],
  name: "AskCode",
  head: {
    title: function () {
      return {
        inner: "",
        separator: " ",
        complement: "Portal Corporativo Bilheteria.com",
      };
    },
  },
  components: {},
  directives: {},
  computed: {},
  methods: {
    login() {
      corporateService
        .validarCodigo(this.form.pass)
        .then((response) => {
          this.processing = false;
          this.hideWaitAboveAll();
          this.$wait.end("inprocess");
          console.log('response: ');
          console.log(response);
          if (response.id) {
            localStorage.setItem(
              "ticket-office-corporate",
              JSON.stringify(response)
            );
            partnerService.getinfo().then(
            (response) => {
              if (response.error) {
                console.log('getinfoerror', response.error)
              }
              if (this.validateJSON(response)) {
                this.$route.matched[0].instances.default.$parent.loginAfterCode(response.require_login);
              }
              sessionStorage.setItem('ask-code-result', true)
              const getCorporateStartPath = sessionStorage.getItem('bilheteria-first-path-received')
              this.$router.push(getCorporateStartPath ? getCorporateStartPath : '/')
            }
          )
          } else {
            this.toastError("Código inválido.");
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    closeloginfather() {
      this.$route.matched[0].instances.default.$parent.modal_close_login();
    },
    getinfo() {
      this.processing = true;
      partnerService.getinfo().then(
        (response) => {
          this.loaded = true;
          this.processing = false;
          if (this.validateJSON(response)) {
            //console.log(response);
            // this.initfb(response.hasfb, response.fb_appid);
          }
        },
        (error) => {
          this.loaded = true;
          this.processing = false;
        }
      );
    },
  },
  data() {
    return {
      processing: false,
      loaded: false,
      showwatch: "login",
      iscreatedvisible: true,
      hasfb: false,
      token: "",
      validateinfo: {
        login: true,
        pass: true,
        // passcode: true,
      },
      form: {
        auth_type: "",
        login: "",
        pass: "",
      },
    };
  },
  mounted() {
    this.$modal.hide("login");
  },


  created() {
      if(this.$route.query.code ){    
              this.$router.push("/"); 
        }

    this.ls_remove("fb_connect");
    this.getinfo();

    switch (window.location.pathname) {
      case "/loginandshopping/printafter":
        this.iscreatedvisible = false;
        break;
    }

    // this.getWindow.fbAsyncInit = function() {
    // }
  },
};
</script>

<style lang="scss">
.container-prime {
  padding: 5px !important;
}

.container-social {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.social-media {
  width: 300px;
  // height: 300px;
}

.social-media-img {
  width: 40px;
  margin: 5px;
  transition: 0.5s ease-out !important;
}

.social-media-img:hover {
  transform: scale(1.2) !important;
  transition: 0.5s ease-out;
}

.container__ask_code {
  .to-block .to-box {
    background: #000 !important;
  }
  .to-box:hover {
    box-shadow: none !important;
  }
  .to-block .to-touch {
    border: none;
  }
  .txts-askcode-bilheteria,
  .txts-resetcode-bilheteria {
    font-size: 22px;
    color: #fff;
    margin: 0 auto;
  }

  .txts-askcode-bilheteria {
    width: 260px;
  }

  .txts-resetcode-bilheteria {
    margin-bottom: 6px;
    font-size: 15px;
  }

  /* sign in FORM */
  #logreg-forms {
    width: 312px;
    margin: 10vh auto;
    background-color: #f3f3f3;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  }

  #logreg-forms form {
    width: 100%;
    max-width: 310px;
    padding: 15px;
    margin: auto;
  }

  #logreg-forms .form-control {
    position: relative;
    box-sizing: border-box;
    height: auto;
    padding: 10px;
    font-size: 16px;
  }

  #logreg-forms .form-control:focus {
    z-index: 2;
  }

  #logreg-forms .form-signin input[type="email"] {
    margin-bottom: -1px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  #logreg-forms .form-signin input[type="password"] {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  #logreg-forms .social-login {
    width: 240px;
    margin: 0 auto;
    margin-bottom: 10px;

    &:hover {
      cursor: default;
    }
  }

  #logreg-forms .social-btn {
    font-weight: 100;
    color: white;
    width: 190px;
    font-size: 0.9rem;
  }

  #logreg-forms a {
    display: block;
    padding-top: 10px;
    color: lightseagreen;
  }

  #logreg-form .lines {
    width: 200px;
    border: 1px solid red;
  }

  .notimplemented {
    display: none !important;
  }

  #logreg-forms button[type="submit"] {
    margin-top: 10px;
  }

  #logreg-forms .facebook-btn {
    background-color: #3c589c;
  }

  #logreg-forms .google-btn {
    background-color: #df4b3b;
  }

  #logreg-forms .form-reset,
  #logreg-forms .form-signup {
    display: none;
  }

  #logreg-forms .form-signup .social-btn {
    width: 210px;
  }

  #logreg-forms .form-signup input {
    margin-bottom: 2px;
  }

  .form-signup .social-login {
    width: 210px !important;
    margin: 0 auto;
  }

  .icon-form {
    position: absolute;
    left: 0;
    margin-left: 13px;
  }

  .errorinputuser {
    border-color: #eb0000;
    border-style: solid solid solid solid;
  }

  /* Mobile */

  @media screen and (max-width: 500px) {
    #logreg-forms {
      width: 300px;
    }

    #logreg-forms .social-login {
      width: 200px;
      margin: 0 auto;
      margin-bottom: 10px;
    }

    #logreg-forms .social-btn {
      font-size: 1.3rem;
      font-weight: 100;
      color: white;
      width: 200px;
      height: 56px;
    }

    #logreg-forms .social-btn:nth-child(1) {
      margin-bottom: 5px;
    }

    #logreg-forms .social-btn span {
      display: none;
    }

    #logreg-forms .facebook-btn:after {
      content: "Facebook";
    }

    #logreg-forms .google-btn:after {
      content: "Google+";
    }

    .box-btn {
      width: 285px;
    }

    .txts-resetcode-bilheteria {
      width: 100%;
    }

    .txts-login-bilheteria {
      font-size: 19px !important;
      max-width: 100% !important;
    }
  }

  .to-block {
    background: none;
    padding-bottom: 0 !important;
  }

  .to-box {
    cursor: default !important;
  }

  a,
  a:hover {
    background: #fdc80a;
    /* background: -webkit-linear-gradient(#ff244f, #ff3d49); */
    background-clip: border-box;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .divider {
    margin-top: 20px;
    margin-bottom: 20px;
    font-style: italic;
    font-size: 13px;
    line-height: 1em;
    position: relative;
    outline: 0;
    border: 0;
    text-align: center;
    height: 1.5em;
  }

  .divider:before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    width: 100%;
    height: 1px;
    background: #d6dade;
  }

  .divider:after {
    font-size: 13px;
    color: #b2b9c1;
    content: attr(data-content);
    position: relative;
    display: inline-block;
    padding: 0 0.5em;
    line-height: 1.5em;
    background-color: #ffffff;
  }

  .form-control {
    display: block;
    width: 100%;
    height: calc(2.25rem + 0.25rem);
    padding: 0.375rem 0.75rem;
    font-size: 0.85em;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 0.5px solid #eee;
    border-radius: 0.1rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

    &:focus {
      box-shadow: none;
    }
  }

  #cancel_reset {
    &:hover {
      color: #027175;
      text-decoration: none;
    }
  }

  .wrapper_login {
    .icon-case {
      background: none !important;
      position: absolute;
      right: 0;
      margin-right: 30px;
      margin-top: 8px;
      font-size: 16px;
      color: #d3d3d3;
      i {
        font-size: 0.9em !important;
      }
    }
  }

  #app {
    overflow: hidden !important;
  }
}
.container__ask_code {
  background: #000 !important;
  height: 100%;
}

#icon-bilheteria {
  height: 174px;
  img {
    height: 185px;
  }
}

@media screen and (max-width: 800px) {
  #icon-bilheteria {
    text-align: center;
    height: 135px;
    img {
      height: 125px;
    }
  }
  .logo-corporativo-ask-code {
    width: 100% !important;
}
}

.container__ask_code .to-block {
  height: 100vh;
}
.logo-corporativo-ask-code {
  width: 500px;
}
</style>
